// MARK://dhk8/pos/lib/queries/cashcuts
// Queries tipadas de cortes de caja — F4.2 / ADR-0009. El POS lee cortes por el grafo
// (pos-cashcuts, tenant del JWT). Escrituras (registrar corte) siguen REST. Campos inline
// (el preset `client` de codegen NO evalúa interpolaciones en el tag `graphql`).
import { graphql } from '../../gql/index.js'

export const PosCashCutsQuery = graphql(`
  query PosCashCuts($branchId: String, $shiftId: String, $kind: String, $page: Int, $limit: Int) {
    cashCuts(branchId: $branchId, shiftId: $shiftId, kind: $kind, page: $page, limit: $limit) {
      total
      page
      limit
      items {
        id tenantId branchId shiftId cashierId kind expectedCents countedCents varianceCents notes createdAt
        denominations { denomination count }
      }
    }
  }
`);

export const PosCashCutQuery = graphql(`
  query PosCashCut($id: ID!) {
    cashCut(id: $id) {
      id tenantId branchId shiftId cashierId kind expectedCents countedCents varianceCents notes createdAt
      denominations { denomination count }
    }
  }
`);

// D3 — totales de pago por método en la ventana del turno (pos-orders subgraph,
// mismo gateway federado). Concilia el Corte de Caja con ventas REALES.
export const PaymentTotalsByMethodQuery = graphql(`
  query PaymentTotalsByMethod($from: String!, $to: String!, $branchId: String) {
    paymentTotalsByMethod(from: $from, to: $to, branchId: $branchId) {
      method
      ticketCount
      totalCents
    }
  }
`);

// Efectivo esperado del turno, derivado por el SERVIDOR (money-path autoritativo):
// fondo + ventas efectivo del turno + ingresos − retiros. Reemplaza el cálculo
// frágil del cliente (day-scoped, sin restar retiros) que dejaba "remanente" falso.
export const PosCashCutExpectedQuery = graphql(`
  query PosCashCutExpected($shiftId: String!, $branchId: String) {
    cashCutExpected(shiftId: $shiftId, branchId: $branchId) {
      expectedCents fondoCents cashSalesCents pickupsCents dropsCents
    }
  }
`);

export const PosCreateCashCutMutation = graphql(`
  mutation PosCreateCashCut($input: CreateCashCutInput!) {
    createCashCut(input: $input) { id tenantId branchId shiftId cashierId kind expectedCents countedCents varianceCents notes createdAt denominations { denomination count } }
  }
`);
